<template>
  <el-row class="index-main">
    <el-row class="yujing">
      <el-row>
        <span style="font-size: 20px; color: #888888">预警提醒</span>
        <span class="fr" style="font-size: 16px; color: #888888"
          >我的余额：{{ price }}元
          <el-button
            type="primary"
            style="margin-left: 10px"
            @click="toUrl('/wallet/balance-desc')"
            >充值</el-button
          ></span
        >
      </el-row>
      <el-row style="margin-top: 35px">
        <ul class="my-ul">
          <li class="center hand" @click="toError">
            <el-row class="round red">{{ vehicle_not_sum }}</el-row>
            <el-row class="mt-15">认证失败（单）</el-row>
          </li>
          <li
            class="center hand"
            @click="
              toUrl(
                '/settle/waybill-apply-list?pay_audit_status=NotAuditPass',
                'CAIWUGUANLI_SHENQINGYUNFEI'
              )
            "
          >
            <el-row class="round blue">{{ audit_failing }}</el-row>
            <el-row class="mt-15">审核失败 （单）</el-row>
          </li>
          <li
            class="center hand"
            @click="
              toUrl(
                '/settle/waybill-apply-list?active=active',
                'CAIWUGUANLI_SHENQINGYUNFEI'
              )
            "
          >
            <el-row class="round yellow">{{ failing_waybill }}</el-row>
            <el-row class="mt-15">支付失败（笔）</el-row>
          </li>
          <!-- 财务管理---运费支付--运单支付页面 -->
          <li
            class="center hand"
            @click="
              toUrl('/settle/waybill-pay-list?num=0', 'CAIWUGUANLI_YUNFEIZHIFU')
            "
          >
            <el-row class="round green">{{ freight }}</el-row>
            <el-row class="mt-15">待支付运费（元）</el-row>
          </li>
          <!-- 财务管理---申请开票--物流辅助费支付页面 -->
          <!-- <li class="center hand" @click="toUrl('/settle/waybill-pay-list?num=1','CAIWUGUANLI_YUNFEIZHIFU')">
            <el-row class="round green">{{assistance_fee}}</el-row>
            <el-row class="mt-15">待支付辅助费（元）</el-row>
          </li> -->
          <li
            class="center"
            @click="
              toUrl(
                '/settle/ticket-apply-list?num=0',
                'CAIWUGUANLI_SHENQINGKAIPIAO_YUNFEIKAIPIAO'
              )
            "
          >
            <el-row class="round green">{{ invoice_amount }}</el-row>
            <el-row class="mt-15">待开票（元）</el-row>
          </li>
        </ul>
      </el-row>
    </el-row>
    <el-row class="box main-bd">
      <el-row class="list-title clearfix">
        <span class="mainColor hand fr" @click="toUrl('/waybill/waybill-list')">
          更多运单 >
        </span>
      </el-row>

      <el-table
        class="nth"
        :empty-text="empty_text"
        border
        :data="data.content"
        ref="multipleTable"
        style="width: 100%"
      >
        <el-table-column align="left" min-width="70" label="基本信息">
          <template slot-scope="scope">
            <el-row class="grayColor">{{ scope.row.create_time }}</el-row>
            <el-row class="number">
              <a
                class="mainColor f14"
                @click="
                  toUrl(
                    '/waybill/waybill-details-details?pid=' + scope.row.pid,
                    'YUNDANLIEBIAO_XIANGQING'
                  )
                "
                >{{ scope.row.waybill_code }}</a
              >
            </el-row>
            <el-row
              >{{ scope.row.operator }}
              <span class="mark" v-if="scope.row.source_type == 'Entrust'"
                >委</span
              >
              <!-- <img src="../assets/images/my-icon1.png" alt="" class="waybill-tag" v-if="scope.row.ship_car_type == 'CAR_TYPE'">
              <img src="../assets/images/my-icon7.png" alt="" class="waybill-tag" v-if="scope.row.ship_car_type == 'BOAT_TYPE'"> -->
            </el-row>
          </template>
        </el-table-column>
        <el-table-column align="left" label="结算信息">
          <template slot-scope="scope">
            <ul>
              <li>结算：{{ scope.row.client_name }}</li>
              <li>委托方：{{ scope.row.entrusting_per }}</li>
            </ul>
          </template>
        </el-table-column>
        <el-table-column align="left" label="车辆信息" min-width="80">
          <template slot-scope="scope">
            <el-row v-if="scope.row.is_owner == 'No'">
              <el-row v-if="scope.row.ship_car_type == 'CAR_TYPE'">
                <a
                  class="mainColor"
                  @click="
                    toUrl(
                      '/vehicle/vehicle-car-detail-detail?pid=' +
                        scope.row.boat_car_pid,
                      'YUNLIKU_CHELIANGGUANLI_CHELIANGSIJIXIANGQING'
                    )
                  "
                  >{{ scope.row.ship_car_num }}</a
                >
                <img
                  src="../assets/images/audit-yes.png"
                  class="audit-image"
                  alt=""
                  v-if="scope.row.audit_status == 'AuditPass'"
                />
                <img
                  src="../assets/images/audit-no.png"
                  class="audit-image"
                  alt=""
                  v-if="scope.row.audit_status == 'AuditNotPass'"
                  @click="
                    toUrl(
                      '/vehicle/vehicle-car-verify?pid=' +
                        scope.row.boat_car_pid
                    ) +
                      '&num=' +
                      1
                  "
                />
                <img
                  src="../assets/images/audit.png"
                  class="audit-image"
                  alt=""
                  v-if="scope.row.audit_status == 'WaitAudit'"
                  @click="
                    toUrl(
                      '/vehicle/vehicle-car-verify?pid=' +
                        scope.row.boat_car_pid
                    ) +
                      '&num=' +
                      1
                  "
                />
              </el-row>
              <el-row v-if="scope.row.ship_car_type == 'BOAT_TYPE'">
                <a
                  class="mainColor"
                  @click="
                    toUrl(
                      '/vehicle/vehicle-ship-detail?pid=' +
                        scope.row.boat_car_pid,
                      'YUNLIKU_CHUANBOGUANLI_CHAKANCHUANBO'
                    )
                  "
                  >{{ scope.row.ship_car_num }}</a
                >
                <img
                  src="../assets/images/audit-yes.png"
                  class="audit-image"
                  alt=""
                  v-if="scope.row.audit_status == 'AuditPass'"
                />
                <img
                  src="../assets/images/audit-no.png"
                  class="audit-image"
                  alt=""
                  v-if="scope.row.audit_status == 'AuditNotPass'"
                  @click="
                    toUrl(
                      '/vehicle/vehicle-ship-verify?pid=' +
                        scope.row.boat_car_pid +
                        '&num=1'
                    )
                  "
                />
                <img
                  src="../assets/images/audit.png"
                  class="audit-image"
                  alt=""
                  v-if="scope.row.audit_status == 'WaitAudit'"
                  @click="
                    toUrl(
                      '/vehicle/vehicle-ship-verify?pid=' +
                        scope.row.boat_car_pid +
                        '&num=1'
                    )
                  "
                />
              </el-row>
            </el-row>
            <el-row v-else>
              <el-row>
                {{ scope.row.ship_car_num }}
                <img
                  src="../assets/images/audit-yes.png"
                  class="audit-image"
                  alt=""
                  v-if="scope.row.audit_status == 'AuditPass'"
                />
                <img
                  src="../assets/images/audit-no.png"
                  class="audit-image"
                  alt=""
                  v-if="scope.row.audit_status == 'AuditNotPass'"
                />
                <img
                  src="../assets/images/audit.png"
                  class="audit-image"
                  alt=""
                  v-if="scope.row.audit_status == 'WaitAudit'"
                />
              </el-row>
            </el-row>
            <el-row
              >{{ scope.row.carrier_name }}<br />{{
                scope.row.accompany_mobile
              }}</el-row
            >
          </template>
        </el-table-column>
        <el-table-column align="left" label="轨迹信息" min-width="100">
          <template slot-scope="scope">
            <ul>
              <li>
                <i
                  class="iconfont icon-icon48 mainColor"
                  v-if="
                    scope.row.trajectory == 'START' ||
                    scope.row.trajectory == 'STARTANDEND'
                  "
                ></i
                ><i v-else class="iconfont icon-icon48 grayColor"></i
                >{{ scope.row.loading_address_province }}/{{
                  scope.row.loading_address_city
                }}/{{ scope.row.loading_address_area }}
              </li>
              <li>
                <i
                  class="iconfont icon-icon48 darkColor"
                  v-if="
                    scope.row.trajectory == 'END' ||
                    scope.row.trajectory == 'STARTANDEND'
                  "
                ></i
                ><i v-else class="iconfont icon-icon48 grayColor"></i
                >{{ scope.row.unloading_address_province }}/{{
                  scope.row.unloading_address_city
                }}/{{ scope.row.unloading_address_area }}
              </li>
            </ul>
            <ul>
              <li>定位状态：{{ scope.row.position_status_enum_text }}</li>
            </ul>
            <el-tooltip
              class="item"
              effect="dark"
              :content="car_location_price"
              placement="top"
              v-if="scope.row.ship_car_type == 'CAR_TYPE'"
            >
              <a
                class="popbtn mainColor"
                @click="$refs.WaybillPositionMap.show(scope.row.pid)"
              >
                <i class="iconfont icon-icon49"></i>定位</a
              >
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="ship_location_price"
              placement="top"
              v-else
            >
              <a
                class="popbtn mainColor"
                @click="$refs.WaybillPositionMap.show(scope.row.pid)"
              >
                <i class="iconfont icon-icon49"></i>定位</a
              >
            </el-tooltip>
            <a
              class="popbtn mainColor"
              @click="
                $refs.WaybillMap.show(scope.row, scope.row.waybill_related_pid)
              "
            >
              <i class="iconfont icon-icon50"></i>查看轨迹</a
            >
            <a
              class="popbtn mainColor"
              v-auth="'YUNDANGENZONG_YUNDANLIEBIAO_CHAKANGUIJIGAODE'"
              @click="
                $refs.WaybillLineMap.show(
                  scope.row.pid,
                  scope.row.ship_car_type
                )
              "
            >
              <i class="iconfont icon-icon50"></i>查看轨迹</a
            >
          </template>
        </el-table-column>
        <el-table-column align="left" label="支付信息" min-width="65">
          <template slot-scope="scope">
            <ul>
              <li>运输金额：￥{{ scope.row.sum_carriage }}</li>
              <li>已付金额：￥{{ scope.row.paid_amount }}</li>
              <li>未付金额：￥{{ scope.row.unpaid_amount }}</li>
              <li>吨位：{{ scope.row.weights }} 吨</li>
            </ul>
          </template>
        </el-table-column>
        <el-table-column align="left" label="结算状态">
          <template slot-scope="scope">
            <ul>
              <li>
                回单：
                <span>{{ scope.row.receipt_status_enum_text }}</span>
                <customer-view :row="scope.row" />
              </li>
              <li v-if="scope.row.is_insure == 'Yes'">
                保险：
                <span
                  >已投保
                  <a @click="getInsure(scope.row.insure_pdf_url)">
                    <i
                      class="iconfont icon-icon75 mainColor"
                      style="
                        font-size: 24px;
                        position: absolute;
                        top: 34px;
                        left: 47%;
                      "
                    ></i></a
                ></span>
              </li>
              <li v-else>
                保险：
                <span>未投保</span>
              </li>
              <li v-if="is_need_single_agreement == 'Yes'">
                运输合同：
                <span v-if="scope.row.is_contract == 'Yes'"
                  >已上传<a @click="getContract(scope.row.pid)"
                    ><i
                      class="iconfont icon-yishangchuan mainColor"
                      style="font-size: 23px"
                    ></i></a
                ></span>
                <span v-else>未上传</span>
                <!-- <customer-view :row="scope.row" /> -->
              </li>
              <li>支付：{{ scope.row.waybill_pay_status_enum_text }}</li>
              <li>开票：{{ scope.row.invoice_status_enum_text }}</li>
              <li v-if="scope.row.pay_time">
                最新支付时间：{{ scope.row.pay_time }}
              </li>
            </ul>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="60">
          <template slot-scope="scope">
            <el-row v-if="scope.row.is_owner == 'No'">
              <el-row>
                <el-button
                  type="text"
                  v-auth="'YUNDANLIEBIAO_BIANJI'"
                  @click="
                    toUrl('/waybill/waybill-details?pid=' + scope.row.pid)
                  "
                  :disabled="scope.row.bianji"
                  >编辑</el-button
                >
                <el-button
                  v-if="scope.row.commission_id && scope.row.dispatch_id"
                  type="text"
                  @click="
                    transfer(scope.row.commission_id, scope.row.dispatch_id)
                  "
                  >客户收货</el-button
                >
              </el-row>
              <el-row>
                <el-button
                  type="text"
                  @click="$refs.WaybillReceipt.show(scope.row)"
                  >上传回单</el-button
                >
              </el-row>
              <el-row>
                <el-button
                  type="text"
                  @click="$refs.AgreementModel.show(scope.row)"
                  v-if="is_need_single_agreement == 'Yes'"
                  >上传运输合同</el-button
                >
              </el-row>
              <el-row>
                <el-button
                  type="text"
                  @click="delWaybill(scope.row.pid)"
                  :disabled="scope.row.pay_status == 'PaymentEnd'"
                  >删除</el-button
                >
              </el-row>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!-- 轨迹 -->
    <waybill-line-map ref="WaybillLineMap" />
    <!-- 定位地图 -->
    <waybill-position-map ref="WaybillPositionMap" />
    <!-- 弹窗  上传回单 -->
    <waybill-receipt ref="WaybillReceipt" @upup="loadList()" />
    <!-- 查看轨迹 -->
    <waybill-map ref="WaybillMap" />
    <!-- 单笔运输合同 -->
    <agreement-model ref="AgreementModel" @upup="loadList()" />
  </el-row>
</template>
<script>
import { isSuccess } from "@/assets/js/utils";
import CustomerView from "@/components/customer/customer-view";
import WaybillLineMap from "@/components/dialog/waybill-line-map";
import WaybillReceipt from "@/components/dialog/waybill-receipt";
import WaybillPositionMap from "@/components/dialog/waybill-position-map";
import AgreementModel from "@/components/details/agreement-model";
export default {
  data() {
    return {
      data: {
        content: [],
      },
      ship_location_price: null,
      car_location_price: null,
      price: null,
      vehicle_not_sum: null,
      failing_waybill: null,
      audit_failing: null,
      await_pay: null,
      empty_text: "数据更新中，请稍后",
      image_url_list: [],
      dialogReceiptVisible: false,
      search: {
        paging: {
          page_size: 5,
          total: 0,
          pages: 0,
          page_num: 1,
        },
      },
      rr: {
        commission_id: "",
        dispatch_id: "",
        status: "6",
        status_name: "客户收货",
      },
      assistance_fee: null,
      freight: null,
      is_need_single_agreement: "",
    };
  },

  mounted() {
    this.loadList();
    //导入运单收费
    api("account.permissions", {}).then((res) => {
      let data = isSuccess(res);
      this.car_location_price = `精确定位一次收费${data.location_charge}元，请悉知！`;
      this.ship_location_price = `精确定位一次收费${data.ship_location_charge}元，请悉知！`;
      this.is_need_single_agreement = data.is_need_single_agreement;
    });
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (val.path == "/") {
          this.loadList();
        }
      },
      deep: true,
    },
  },
  components: {
    CustomerView,
    WaybillLineMap,
    WaybillReceipt,
    WaybillPositionMap,
    AgreementModel,
  },
  methods: {
    //下载保险保单，运输合同
    getInsure(url) {
      window.open(url);
    },
    getContract(pid) {
      api("waybill.agreement.query", { id: pid }).then((res) => {
        let data;
        if ((data = isSuccess(res))) {
          window.open(data.agreement_url);
        } else {
          alert(res.msg);
        }
      });
    },
    //节点更新
    transfer(commission_id, dispatch_id) {
      if (confirm("确认更新客户收货节点？")) {
        this.rr.commission_id = commission_id;
        this.rr.dispatch_id = dispatch_id;
        //弹窗确定是否操作
        api("entrust.transfer", this.rr).then((res) => {
          alert(res.msg);
        });
      }
    },
    //删除
    delWaybill(pid) {
      if (confirm("确认删除")) {
        api("waybill.waybill.delete", { id: pid }).then((res) => {
          let data;
          alert(res.msg);
          if ((data = isSuccess(res))) {
            this.loadList();
          }
        });
      }
    },
    //搜索列表
    loadList() {
      api("wallet.all.fee.type.amount", { account_type: "LOGIN_USER" }).then(
        (res) => {
          let data;
          if ((data = isSuccess(res))) {
            this.price = data.balance;
          }
        }
      );
      api("indexsum.pay.failing.waybill").then((res) => {
        let data = isSuccess(res);
        this.failing_waybill = data;
      });
      api("indexsum.vehicle.not").then((res) => {
        let data = isSuccess(res);
        if (data.car_num == 0) {
          this.vehicle_not_sum = data.ship_num;
          this.num = 1;
        } else {
          this.num = 0;
          this.vehicle_not_sum = data.car_num;
        }
      });
      api("indexsum.audit.failing.waybill").then((res) => {
        let data = isSuccess(res);
        this.audit_failing = data;
      });
      api("indexsum.await.pay.waybill").then((res) => {
        let data = isSuccess(res);
        this.await_pay = Math.floor(data);
      });
      api("indexsum.not.invoice.amount.sum").then((res) => {
        let data = isSuccess(res);
        this.invoice_amount = Math.floor(data);
      });
      // 待支付-运费
      api("waybill.sum.payable.amount", { payment_status: "AwaitPay" }).then(
        (res) => {
          let data = isSuccess(res);
          this.freight = Math.floor(data.payable_amount + data.service_amount);
        }
      );
      // 待支付-物流辅助费
      api("indexsum.waybill.subsidiary.sum").then((res) => {
        let data = isSuccess(res);
        this.assistance_fee = Math.floor(data);
      });
      api("waybill.batch.query", this.search).then((res) => {
        let data;
        if ((data = isSuccess(res))) {
          this.data.content = data;
          this.page_total = res.data_total;
          if (this.data.content.length == 0) {
            this.empty_text = "暂无数据";
          }
          this.data.content.forEach((item) => {
            if (item.pay_status == "PaymentEnd") {
              item.bianji = true;
            } else {
              item.bianji = false;
            }
          });
          this.search.paging.total = res.data_total;
        } else {
          this.data.content = [];
          this.search.paging.total = 1;
        }
      });
    },
    toError() {
      // this.num = 0跳转到车
      if (this.num == 0) {
        toUrl(
          "/vehicle/vehicle-car-list?audit_status=AuditNotPass",
          "YUNLIKU_CHELIANGGUANLI"
        );
      } else {
        toUrl(
          "/vehicle/vehicle-ship-list?audit_status=AuditNotPass",
          "YUNLIKU_CHUANBOGUANLI"
        );
      }
    },
  },
};
</script>
<style scoped lang="scss">
.yujing {
  height: 260px;
  background: #fff;
  margin-bottom: 30px;
  padding: 30px;
}
.center {
  text-align: center;
  float: left;
  // margin-left: 8.5%;
}
.waybill-tag {
  margin-left: 5%;
  position: absolute;
  top: 2px;
}
.my-ul {
  display: flex;
  justify-content: space-around;
}
</style>



// WEBPACK FOOTER //
// src/views/index-tax.vue